module.exports = __webpack_public_path__ + "img/新疆有色.885d0c3a.png";